import { useIntl } from 'react-intl'
import { useConfiguration } from 'contexts/configuration'
import { getFullName } from 'utilities/person'

export const useIsEntity = () => {
    const { getKnownGroupTypes } = useConfiguration()
    return entity => ['user', ...getKnownGroupTypes()].includes(entity?.entityType)
}

export const isFavorite = (item, favorites) => !!favorites.find(favorite => {
    const isEntity = useIsEntity()

    if(isEntity(favorite)) {
        const { type } = favorite

        return favorite[type]?.id === item[type]?.id
    }

    if(favorite?.actionId) {
        return favorite.actionId === item?.actionId
    }

    return favorite.id === item.id
})

export const useGetItemLabel = () => {
    const { formatMessage } = useIntl()

    return item => {
        if(item?.label) {
            if(item.label.id) {
                return formatMessage(
                    item.label,
                    item.label.values || {}
                )
            }

            return item.label
        } else if(item?.type === 'entity') {
            if(item.entityType === 'user') {
                return getFullName(item.entity)
            }

            return item.entity.name
        } else if(item?.heading) {
            return item.heading
        }

        return item?.name ?? ''
    }
}

export const checkIsSavable = item => (item?.savable !== false)

export const parseInput = input => {
    const parts = input.trim().split(' ')
    let lastPart = ''

    if(parts.length > 1) {
        lastPart = parts.pop()
    }

    return {
        query: parts.join(' '),
        potentialMatch: lastPart
    }
}

export  const getStringOrRegexMatcher = searchPhrase => matchPhrase => {
    if(!!matchPhrase?.text) {
        matchPhrase = matchPhrase.text
    }

    searchPhrase = searchPhrase.toLowerCase()

    if(typeof matchPhrase === 'string') {
        matchPhrase = matchPhrase.toLowerCase()
        return matchPhrase.includes(searchPhrase) || searchPhrase.split(' ').every(part => matchPhrase.includes(part))
    }

    if(matchPhrase instanceof RegExp) {
        return matchPhrase.test(searchPhrase)
    }

    return false
}

export const checkIsQueryValid = query => query.trim().length >= 2